var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"footer"},[_vm._m(0),_c('div',[_c('span',{staticClass:"privacy",on:{"click":_vm.toPrivacyPage}},[_vm._v("Terms and Conditions")]),_c('span',{staticClass:"visitable-switch"},[_vm._v("Copyright © 2022 616Catering Management Ltd. All Rights Reserved.")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"visitable-switch"},[_vm._v("616餐飲管理有限公司")])])
}]

export { render, staticRenderFns }